// extracted by mini-css-extract-plugin
export default {"tablet":"(min-width: 768px)","black":"#000000","link":"A","clearfix":"B","closed":"C","open":"D"};